export default "/assets/8d513ad94829ef391cd18d4a83bcfc4b.woff";